import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--preview-modal"
// 履歴書 / 職務経歴書のプレビューモーダル表示用コントローラー
export default class extends Controller {
  static targets = ["title", "frame", "printButton"];

  open(e) {
    e.preventDefault();

    const trigger = e.currentTarget;
    const url = trigger.dataset.previewUrl;
    const type = trigger.dataset.previewType;
    const printUrl = trigger.dataset.printUrl;

    if (!url || !type) {
      return;
    }

    // タイトルを種別に応じて切り替え
    const titleText =
      type === "skill" ? "職務経歴書プレビュー" : "履歴書プレビュー";

    if (this.hasTitleTarget) {
      this.titleTarget.textContent = titleText;
    }

    // iframe にプレビューURLを設定
    if (this.hasFrameTarget) {
      this.frameTarget.src = url;
    }

    // コンビニ印刷ボタンのリンクを設定
    if (this.hasPrintButtonTarget && printUrl) {
      this.printButtonTarget.href = printUrl;
    }
  }

  closeAndRemovePreview() {
    if (!this.hasFrameTarget) return;

    const iframeDoc = this.frameTarget.contentDocument;
    if (!iframeDoc) return;

    const canvas = iframeDoc.getElementById("preview");
    if (canvas) {
      canvas.remove();
    }
  }
}
